import { CopySource } from './../../../../pipeline/copysource/copysource';
import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { BlobTypeStoreReadSettingsAdapter, blobTypeStoreReadSettingsAdapts } from './blob-type-store-read-settings.adapter';
import { HdfsStoreReadSettings, DistcpSetting } from 'app/model/pipeline/copysource/store-read-settings/hdfs-store-read-settings';
import { ValueAdapter } from 'app/model/adapters/value.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(HdfsStoreReadSettings),
    asynchronous: true,
    adapts: {
        ...blobTypeStoreReadSettingsAdapts,
        distcpSettings: '*'
    }
})
export class HdfsStoreReadSettingsAdapter extends BlobTypeStoreReadSettingsAdapter<HdfsStoreReadSettings, Model.HdfsStoreReadSettings> {
    protected override async _toResource(model: HdfsStoreReadSettings): Promise<Model.HdfsStoreReadSettings> {
        const resource = await super._toResource(model);
        if (model != null && resource != null) {
            if (model.distCpSetting && model.distCpSetting.useDistCp) {
                resource.distcpSettings = {
                    resourceManagerEndpoint: ValueAdapter.toResource(model.distCpSetting, DistcpSetting.RESOURCE_MANAGER_ENDPOINT),
                    tempScriptPath: ValueAdapter.toResource(model.distCpSetting, DistcpSetting.TEMP_SCRIPT_PATH),
                    distcpOptions: ValueAdapter.toResource(model.distCpSetting, DistcpSetting.DIST_CP_OPTIONS)
                };
            }
            resource.deleteFilesAfterCompletion = ValueAdapter.toResource(model, HdfsStoreReadSettings.DELETE_FILE_AFTER_COMPLETION);
        }
        return resource;
    }

    protected override async _toModel(resource: Model.HdfsStoreReadSettings, copySource: CopySource): Promise<HdfsStoreReadSettings> {
        const model = await super._toModel(resource, copySource);
        if (resource != null && model != null) {
            if (resource.distcpSettings) {
                model.distCpSetting.useDistCp = true;
                ValueAdapter.toModel(model.distCpSetting, DistcpSetting.RESOURCE_MANAGER_ENDPOINT, resource.distcpSettings.resourceManagerEndpoint);
                ValueAdapter.toModel(model.distCpSetting, DistcpSetting.TEMP_SCRIPT_PATH, resource.distcpSettings.tempScriptPath);
                ValueAdapter.toModel(model.distCpSetting, DistcpSetting.DIST_CP_OPTIONS, resource.distcpSettings.distcpOptions);
            }
            ValueAdapter.toModel(model, HdfsStoreReadSettings.DELETE_FILE_AFTER_COMPLETION, resource.deleteFilesAfterCompletion);
        }
        return model;
    }
}
